var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-2xl"},[_vm._v("Work in progress")])}
var staticRenderFns = []

export { render, staticRenderFns }